import { useQueryClient } from "@tanstack/react-query";
import { getQueryKey } from "@trpc/react-query";
import { trpc } from "../trpc";

export function useRequestApproval() {
  const queryClient = useQueryClient();

  const approvalKey = getQueryKey(trpc.approval.approvals, undefined, "any");

  const mutation = trpc.approval.request.useMutation({
    // Callback to handle optimistic updates in RQ cache
    onMutate: () => {
      queryClient.cancelQueries({ queryKey: approvalKey });
    },
    // Callback to handle cache invalidation after mutation is completed
    onSettled: () => {
      queryClient.invalidateQueries({
        queryKey: approvalKey,
        refetchType: "all",
      });
    },
  });

  return {
    requestApproval: mutation.mutate,
    isLoading: mutation.isPending,
  };
}
